'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function MoneyUpDashboardHomeLoans() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _MoneyUpDashboardHomeBase];
  this._history = new History();

  this.presenter = null;
  this.analytics = null;
  this.onComplete = function () {};

  this._connectionIssueConfig = null;

  this._DEBUG = false;

  this._classNames = {
    referral: MoneyUpProductCell.classNames.inactive,
    preapprovalLiquid: MoneyUpProductCell.classNames.inactive,
    preapprovalMini: MoneyUpProductCell.classNames.inactive,
    preapproval_pending: MoneyUpProductCell.classNames.loading,
    inProgressLiquid: MoneyUpProductCell.classNames.active,
    inProgressMini: MoneyUpProductCell.classNames.active,
    noOffers: MoneyUpProductCell.classNames.inactive,
    offerExpiredLiquid: MoneyUpProductCell.classNames.inactive,
    offerExpiredMini: MoneyUpProductCell.classNames.inactive,
    genericFS: MoneyUpProductCell.classNames.active,
    inProgressFS: MoneyUpProductCell.classNames.active,
    defaultMini: MoneyUpProductCell.classNames.inactive,
    default: MoneyUpProductCell.classNames.inactive
  };

  this._disclaimers = {
    inProgressLiquid: {
      text: 'disclaimer.mogoDigitalLoanPreApproval',
      position: 'content'
    },
    inProgressMini: {
      text: 'disclaimer.mogoMiniStandard',
      position: 'content'
    },
    referral: {
      text: 'disclaimer.lendfulInAppDisclosure',
      position: 'content'
    },
    preapprovalLiquid: {
      text: 'disclaimer.mogoDigitalLoanPreApproval',
      position: 'content'
    },
    preapprovalMini: {
      text: 'disclaimer.mogoMiniStandard',
      position: 'content'
    },
    offerExpiredLiquid: {
      text: 'disclaimer.mogoDigitalLoanPreApproval',
      position: 'content'
    },
    offerExpiredMini: {
      text: 'disclaimer.mogoMiniStandard',
      position: 'content'
    },
    defaultMini: {
      text: 'disclaimer.mogoMiniStandard',
      position: 'content'
    },
    default: {
      text: 'disclaimer.mogoDigitalLoanPreApproval',
      position: 'content'
    }
  };

  this.init = function () {
    this._super();
    this._connectionIssueConfig = this._getConnectionIssueConfig();
    $.when(this.presenter._contentLoadedPromise).then(this._setState.bind(this)); // this is going to come back 9 times out of 10 before the cell is ready for it but I'm not refactoring this as well at this point.

    if (this.isPendingLoanOfferDecision()) {
      if (this._DEBUG) console.log('mUPDHL: create cell immediately for TS pending.');
      var cellSettings = {
        product: 'Money',
        contentExtensions: this._content,
        classNameExtensions: this._classNames,
        disclaimers: this._disclaimers
      };

      this._createProductCell(cellSettings); // note: _setState() is called w/ create.onReady
      this._productCell = this._getProductCell();
      this.onComplete(); // tells MainDashboard this component is done
    }
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    if (this._DEBUG) console.log('10. MoneyUpDashboardHomeLoans initPage.');
    if (this.node.querySelector('.js--dashboard-product').mogo().create) {
      if (this._DEBUG) console.log('mUPDHL: cell not created yet so create it. (NOT TS pending state)');

      var cellSettings = {
        product: 'Money',
        contentExtensions: this._content,
        classNameExtensions: this._classNames,
        disclaimers: this._disclaimers
      };

      this._createProductCell(cellSettings); // note: _setState() is called w/ create.onReady
      this._productCell = this._getProductCell();
      this.onComplete(); // tells MainDashboard this component is done
    } else {
      if (this._DEBUG) console.log('mUPDHL: Cell created already - only update state.');
      this._setState();
    }

    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._setState = function () {
    if (!_this.node.querySelector('.js--dashboard-product').mogo().create) {
      _this._productCell = _this._getProductCell();

      var isDecisionPending = _this.isPendingLoanOfferDecision();
      var offerState = _this._getOfferStatus();
      var applicationStatus = _this._getApplicationStatus();
      var applicationState = applicationStatus ? applicationStatus.status : '';
      var loanStatus = _this._getLoanStatus();
      var loanState = loanStatus ? loanStatus.status : '';
      var moneyRoute = _this.determineMoneyRoute();
      var moneyRouteKey = _this._findRouteKey(moneyRoute, _this.paths.loans);
      var digitalLoanStatus = _this.hasCreatedLoanApplication() ? _this._loanApplications[0].getStatus() : '';
      var applicationOnHold = _this._activeOffer && _this._activeOffer.getOfferData() && _this._activeOffer.isOfferPaused();
      var daysBeforeExpiry = _this._getDaysBeforeExpiration();
      var isColdLead = _this.presenter.getModelProperty('account.credit_seeker_status') === 'cold_lead';
      var softDeclineCanRefresh = _this.isSoftDeclineExpired();
      var isReferralOffer = _this.presenter.getModelProperty('money.offers.referral') !== null;
      var isMiniProduct = _this._activeOffer && _this._activeOffer.getOfferName() === 'mini' || _this._expiredOffer && _this._expiredOffer.getOfferName() === 'mini' || _this._previousOffer && _this._previousOffer.getOfferName() === 'mini';

      var productState = 'loading';
      var analyticsState = 'Loading';

      if (isDecisionPending) {
        productState = 'preapproval_pending'; // A.1.1.2.12 PreApproval Pending
        analyticsState = 'PreApproval Pending';
      } else if (isReferralOffer && moneyRouteKey === 'preapproval' && offerState !== 'declined' && offerState !== 'expired' && offerState !== 'refresh' && !isColdLead) {
        productState = 'referral'; // A.1.1.2.8 Referral Offer
        analyticsState = 'Referral Offer';
      } else if (moneyRouteKey === 'preapproval' && offerState !== 'declined' && offerState !== 'expired' && offerState !== 'refresh' && !isColdLead) {
        if (isMiniProduct) {
          productState = 'preapprovalMini'; // A.1.1.2.1
        } else {
          productState = 'preapprovalLiquid'; // A.1.1.2.5
        }
        analyticsState = 'Pre-approval';
      } else if ((moneyRouteKey === 'overview' || moneyRouteKey === 'application_status') && applicationState && digitalLoanStatus !== 'declined' && !applicationOnHold) {
        if (isMiniProduct) {
          productState = 'inProgressMini'; // A.1.1.2.5
        } else {
          productState = 'inProgressLiquid'; // A.1.1.2.5
        }
        analyticsState = 'In Progress';
      } else if (offerState !== 'refresh' && (offerState === 'declined' && !softDeclineCanRefresh || loanState === 'paid_off' && !applicationState || loanState === 'paid_off' && applicationState && applicationState.indexOf('agreements') !== -1 || loanState !== 'active' && digitalLoanStatus === 'declined' || offerState === 'expired' && !digitalLoanStatus)) {
        // Only FS returns expired.
        productState = 'noOffers'; // A.1.1.2.7
        analyticsState = 'No Offers';
      } else if (moneyRouteKey === 'paid_off' && offerState === 'refresh' && !isColdLead) {
        if (isMiniProduct) {
          productState = 'defaultMini'; // A.1.1.2.8 Paid Off Refresh
        } else {
          productState = 'default'; // A.1.1.2.8 Paid Off Refresh
        }
        analyticsState = 'Paid Off Refresh';
      } else if (moneyRouteKey === 'preapproval' && (offerState === 'refresh' || softDeclineCanRefresh) && !isColdLead) {
        if (isMiniProduct) {
          productState = 'defaultMini'; // A.1.1.2.8 PreApproval Refresh / Soft Declined Expired
        } else {
          productState = 'default'; // A.1.1.2.8 PreApproval Refresh / Soft Declined Expired
        }
        analyticsState = 'Pre-approval Refresh';
      } else if (moneyRouteKey === 'preapproval' && offerState === 'declined' && !isColdLead) {
        productState = 'noOffers'; // A.1.1.2.7 Declined
        analyticsState = 'No Offers';
      } else if (moneyRouteKey === 'preapproval' && offerState === 'expired' && !isColdLead) {
        if (isMiniProduct) {
          productState = 'offerExpiredMini'; // A.1.1.2.8
        } else {
          productState = 'offerExpiredLiquid'; // A.1.1.2.8
        }
        analyticsState = 'Offer Expired';
      } else if (moneyRouteKey === 'fs' && applicationState !== 'incomplete') {
        productState = 'genericFS'; // A.1.1.2.9
        analyticsState = 'Generic FS';
      } else if ((applicationState === 'incomplete' || applicationState === 'bank' || applicationState === 'agreements') && daysBeforeExpiry >= 0) {
        productState = 'inProgressFS'; // A.1.1.2.10
        analyticsState = 'In Progress FS';
      } else if (moneyRouteKey === 'overview' && loanState === 'active' || applicationOnHold) {
        productState = 'active'; // A.1.1.2.2
        analyticsState = 'Active';
      } else {
        // Note: inactive state uses content from contentful
        productState = 'inactive'; // A.1.1.2.11
        analyticsState = 'Inactive';
      }

      if (_this._DEBUG) console.log('mUPDHL: _setState:', productState);
      _this._productCell.setState(productState, analyticsState);

      // alert scenarios
      _this._setAlertState(analyticsState);
    } else if (_this._DEBUG) console.warn('mUPDHL: _setState: No Product Cell Found.');
  };

  this._setAlertState = function () {
    if (_this._productCell.getState() === 'preapprovalLiquid' || _this._productCell.getState() === 'preapprovalMini' || _this._productCell.getState() === 'inProgressLiquid' || _this._productCell.getState() === 'inProgressMini' || _this._productCell.getState() === 'offerExpiredLiquid' || _this._productCell.getState() === 'offerExpiredMini' || _this._productCell.getState() === 'inProgressFS') {
      var offerState = _this._getOfferStatus();
      var applicationStatus = _this._getApplicationStatus();
      var applicationState = applicationStatus ? applicationStatus.status : '';
      var agreementsState = _this._getAgreementsStatus();
      var loanStatus = _this._getLoanStatus();
      var loanState = loanStatus ? loanStatus.status : '';
      var moneyRoute = _this.determineMoneyRoute();
      var moneyRouteKey = _this._findRouteKey(moneyRoute, _this.paths.loans);
      var digitalLoanStatus = _this.hasCreatedLoanApplication() ? _this._loanApplications[0].getStatus() : '';
      var daysBeforeExpiry = _this._getDaysBeforeExpiration();
      var aboutToExpire = daysBeforeExpiry !== null && daysBeforeExpiry <= 7;

      if (
      // (A.1.1.2.1 + A.1.1.2.3) Offer - Expiry Coming (Pre-approval Amount) and no active loan app
      moneyRouteKey === 'preapproval' && offerState !== 'declined' && aboutToExpire ||
      // (A.1.1.2.1 + A.1.1.2.3)
      // DLA Offer Expires in x days (Pre-approval amount) with application
      // App status: In Progress, Review, Outstanding Docs, Engage, Agreements Ready, Agreements Expired
      moneyRouteKey === 'application_status' && loanState !== 'pending' && digitalLoanStatus !== 'declined' && digitalLoanStatus !== 'agreements_signed' && digitalLoanStatus !== 'originated' ||
      // Level Up Application
      // App status: In Progress, Review, Outstanding Docs, Engage, Agreements Ready, Agreements Expired
      moneyRouteKey === 'overview' && loanState !== 'pending' && digitalLoanStatus !== 'declined' && digitalLoanStatus !== 'agreements_signed' && digitalLoanStatus !== 'originated' ||
      // (A.1.1.2.1 + A.1.1.2.3) FS Offer - Enhanced Offer
      moneyRouteKey === 'preapproval' && offerState === 'enhanced' ||
      // (A.1.1.2.8 + A.1.1.2.3) FS Offer - Almost Expired Paid Off
      moneyRouteKey === 'preapproval' && offerState === 'active' && loanState === 'paid_off' && aboutToExpire ||
      // FS
      // (A.1.1.2.10 + A.1.1.2.3) FS - Loans Incomplete
      moneyRouteKey === 'fs' && applicationState === 'incomplete' && daysBeforeExpiry >= 0 ||
      // (A.1.1.2.10 + A.1.1.2.3) FS - Loading Agreements
      moneyRouteKey !== 'fs' && applicationState === 'agreements' && (agreementsState === 'pending' || agreementsState === 'error') ||
      // (A.1.1.2.10 + A.1.1.2.3) FS - Sign Agreements
      moneyRouteKey !== 'fs' && applicationState === 'agreements' && agreementsState === 'ready' ||
      // (A.1.1.2.10 + A.1.1.2.3) FS - Loans Incomplete Bank Verification
      moneyRouteKey !== 'fs' && applicationState === 'bank') {
        _this._productCell.showAlert(true);
      } else {
        _this._productCell.showAlert(false);
      }
    } else {
      _this._productCell.showAlert(false);
    }
  };

  // dynamic content construction
  this._getInactiveContentString = function () {
    return _this.presenter.getModelProperty('content.pages.MoneyUpDashboardHome.productTiles.loansInactive.message');
  };

  this._getPreapprovalContentString = function () {
    var intro = 'Pre-approved for up to';
    var offer = _this._activeOffer.getOfferAmount();
    var moneyString = _this._productCell._getFormattedMoneyHtml(offer);
    return intro + '<br>' + moneyString;
  };

  this._getSoaContentString = function () {
    var intro = 'Principal remaining';
    var balance = _this.presenter.getModelProperty('money.loans.loans[0].principal.amount_remaining');
    var moneyString = _this._productCell._getFormattedMoneyHtml(balance);
    return intro + '<br>' + moneyString;
  };

  this._getInProgressContentString = function () {
    var intro = 'Application loan amount';
    // Get user selected amount otherwise, show pre approved amount
    var offer = _this._loanApplications[0].getLoanApplicationAmount() || _this._activeOffer.getOfferAmount();
    var moneyString = _this._productCell._getFormattedMoneyHtml(offer);
    return intro + '<br>' + moneyString;
  };

  this._getOfferExpiredContentString = function () {
    var intro = 'Get up to';
    var offer = _this._expiredOffer.getOfferAmount();
    var moneyString = _this._productCell._getFormattedMoneyHtml(offer);
    return intro + '<br>' + moneyString;
  };

  this._getDefaultPreapprovalContentString = function () {
    var intro = 'Get up to';
    var offer = 35000;
    var moneyString = _this._productCell._getFormattedMoneyHtml(offer);
    return intro + '<br>' + moneyString;
  };

  // define after any methods that are referenced in definition
  this._content = {
    inactive: this._getInactiveContentString,
    active: this._getSoaContentString,
    referral: this._getDefaultPreapprovalContentString,
    preapprovalLiquid: this._getPreapprovalContentString,
    preapprovalMini: this._getPreapprovalContentString,
    preapproval_pending: 'Grabbing your offer, sit back and relax &#128564;',
    inProgressLiquid: this._getInProgressContentString,
    inProgressMini: this._getInProgressContentString,
    noOffers: 'No offers are available right now',
    offerExpiredLiquid: this._getOfferExpiredContentString,
    offerExpiredMini: this._getOfferExpiredContentString,
    genericFS: 'See my status',
    inProgressFS: 'Continue my application',
    defaultMini: this._getDefaultPreapprovalContentString,
    default: this._getDefaultPreapprovalContentString
  };

  // Utilities
  this._findRouteKey = function (path, pathMap) {
    var map = pathMap;

    for (var i = 0; i < Object.keys(map).length; i++) {
      if (_typeof(map[Object.keys(map)[i]]) === 'object') {
        var res = this._findRouteKey(path, map[Object.keys(map)[i]]);
        if (res) return res;
      } else if (map[Object.keys(map)[i]] === path) {
        return Object.keys(map)[i];
      }
    }
    return null;
  };

  this.destroy = function () {
    this._super();
  };
}